import { IWishListResponse, IWishListRow, WISH_LIST_DEFAULT_LIMIT } from '../models/WishList'
/**
 * GET /wish-lists のレスポンスを一覧表示用に正規化する。
 * バックエンドの項目名が異なる場合はここだけ調整する。
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const convertWishListData = (data: any): IWishListResponse => {
  const items = data?.items ?? []
  const rows: IWishListRow[] = items.map((item: any) => ({
    id: String(item?.id ?? ''),
    refNo: item?.refNo ?? '-',
    productCode: item?.productCode ?? '-',
    productName: item?.productName ?? '-',
    displayName: item?.displayName ?? '-',
    makerName: item?.makerName ?? '-',
    carName: item?.carName ?? '-',
    year: item?.year ?? null,
    orderedAt: item?.orderedAt ?? null,
    stockType: item?.stockType ?? '-',
    stockSource: item?.stockSource || '-',
    carModel: item?.carModel ?? '-',
    engineModel: item?.engineModel ?? '-',
    companyName: item?.companyName ?? '-',
    userName: item?.user?.name ?? item?.userName ?? '-',
    isAvailable: item?.isAvailable ?? false,
    status: item?.status,
    withCatalyst: item?.withCatalyst ?? null,
    wishPrice: item?.wishPrice ?? null,    createDate: item?.createdAt ?? item?.createDate ?? 0,
    updateDate: item?.updatedAt ?? item?.updateDate ?? 0,
  }))

  return {
    data: rows,
    pagination: {
      currentPage: data?.pagination?.currentPage ?? 1,
      limitValue: data?.pagination?.limitValue ?? WISH_LIST_DEFAULT_LIMIT,
      totalCount: data?.pagination?.totalCount ?? 0,
      totalPages: data?.pagination?.totalPages ?? 0,
    },
  }
}
